import AGREGAR_MINUTA from '@/graphql/mutations/administracion/minutas/agregarContratoMinuta.gql';
import ACTUALIZAR_MINUTA from '@/graphql/mutations/administracion/minutas/actualizarContratoMinuta.gql';
import REMOVER_MINUTA from '@/graphql/mutations/administracion/minutas/removerContratoMinuta.gql';
import MINUTAS from '@/graphql/querys/administracion/minutas/contratoMinutas.gql';

export default {
  methods: {
    async mixAgregarMinuta() {
      this.mixEsCargando();
      this.enviandoFormulario = true;
      const { idContrato } = this;
      await this.$apollo
        .mutate({
          mutation: AGREGAR_MINUTA,
          variables: { minuta: this.minuta },
          update: (store, { data: { agregarContratoMinuta } }) => {
            const data = store
              .readQuery({
                query: MINUTAS,
                variables: {
                  idContrato,
                },
              });
            data.contratoMinutas.push(agregarContratoMinuta);
            store.writeQuery({
              query: MINUTAS,
              variables: {
                idContrato,
              },
              data,
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixActualizarMinuta() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      const { idContrato } = this.minutaEditar;
      const { id } = this.minutaEditar;
      const { minuta } = this;
      await this.$apollo.mutate({
        mutation: ACTUALIZAR_MINUTA,
        variables: {
          id,
          minuta,
        },
        update: (store, { data: { actualizarContratoMinuta } }) => {
          const data = store
            .readQuery({
              query: MINUTAS,
              variables: {
                idContrato,
              },
            });
          const { contratoMinutas } = data;
          const index = contratoMinutas
            .findIndex((m) => m.id === actualizarContratoMinuta.id);
          if (index !== -1) {
            contratoMinutas.splice(index, 1, actualizarContratoMinuta);
          }
          store.writeQuery({
            query: MINUTAS,
            variables: {
              idContrato,
            },
            data,
          });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixEliminarMinuta() {
      this.mixEsCargando();
      this.enviadoFormulario = true;
      const idMinuta = this.minutaEliminar.id;
      const { idContrato } = this.minutaEliminar;
      await this.$apollo.mutate({
        mutation: REMOVER_MINUTA,
        variables: {
          id: idMinuta,
        },
        update: (store) => {
          const query = {
            query: MINUTAS,
            variables: {
              idContrato,
            },
          };
          const data = store.readQuery(query);
          const index = data.contratoMinutas
            .findIndex(({ id }) => id === idMinuta);
          if (index !== -1) {
            data.contratoMinutas.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
